import { Directive } from '@angular/core';

@Directive({
  selector: '[treeNewNodeDef]'
})
export class TreeNewNodeDefDirective {}
